import { RequestAction, createRequestActionCreators, createAction } from 'helpers/actionsHelpers'
import { ExtendedSubscription, Subscription } from 'interfaces/subscription'
import { SimpleAction } from 'interfaces/action'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'

export class GetSubscriptionAction extends createRequestAction<'GET_SUBSCRIPTION', void, ExtendedSubscription>('GET_SUBSCRIPTION') {}

export const CANCEL_SUBSCRIPTION_CONFIRM = 'CANCEL_SUBSCRIPTION_CONFIRM' as const
type CancelSubscriptionConfirm = RequestAction<typeof CANCEL_SUBSCRIPTION_CONFIRM, {}, {}>
export const cancelSubscriptionConfirmActionCreator = createRequestActionCreators<
  typeof CANCEL_SUBSCRIPTION_CONFIRM,
  {},
  {}
>(CANCEL_SUBSCRIPTION_CONFIRM)

export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION' as const
type CancelSubscription = RequestAction<typeof CANCEL_SUBSCRIPTION, {}, Subscription>
export const cancelSubscriptionActionCreator = createRequestActionCreators<
  typeof CANCEL_SUBSCRIPTION,
  {},
  Subscription
>(CANCEL_SUBSCRIPTION)


export const CLEANUP_SUBSCRIPTION_MESSAGES = 'CLEANUP_SUBSCRIPTION_MESSAGES' as const
export const cleanupSubscriptionMessagesActionCreator = (): SimpleAction<typeof CLEANUP_SUBSCRIPTION_MESSAGES> => createAction(CLEANUP_SUBSCRIPTION_MESSAGES)
type CleanupSubscriptionMessages = ReturnType<typeof cleanupSubscriptionMessagesActionCreator>

export class CreateSubscriptionAction extends createRequestAction<'CREATE_SUBSCRIPTION', { amount: number }, void, void>('CREATE_SUBSCRIPTION') {}
export class PatchSubscriptionAction extends createRequestAction<'PATCH_SUBSCRIPTION', { amount: number }, void, void>('PATCH_SUBSCRIPTION') {}

export type SubscriptionAction =
  | typeof GetSubscriptionAction.Type
  | CancelSubscriptionConfirm
  | CancelSubscription
  | CleanupSubscriptionMessages
  | typeof CreateSubscriptionAction.Type
  | typeof PatchSubscriptionAction.Type
